/**
 * What /licenses shows before the account holds the commercial entitlement.
 *
 * The gate is presentational only — see the note in src/router.tsx. Real
 * entitlement enforcement is a backend concern (Phase 4).
 */
import { BadgeCheck } from 'lucide-react';
import { Btn, SectionHeading, UpgradePrompt } from '../ui';
import { formatUpgradeOfferPriceLine, upgradeOffer } from '../../data/upgradeOffers';
import { c } from '../../styles/theme';

const CERTIFICATION_OFFER = upgradeOffer('commercial-certification');

export interface LicenseLockedStateProps {
  /** Sends the visitor to the product that unlocks this page. */
  onGetLicense: () => void;
}

export default function LicenseLockedState({ onGetLicense }: LicenseLockedStateProps) {
  return (
    <div>
      <SectionHeading
        as="h1"
        icon={<BadgeCheck size={17} color={c.accent} />}
        title="Commercial License"
        subtitle="Proof that you hold a Commercial Creator License to sell, distribute, and monetize your Lyrixsa AI songs."
        marginBottom={18}
      />
      <UpgradePrompt
        paddingY={28}
        icon={<BadgeCheck size={28} color={c.text3} />}
        title="No commercial license yet"
        description={`Add the ${CERTIFICATION_OFFER?.product.name} — ${formatUpgradeOfferPriceLine(
          CERTIFICATION_OFFER?.product ?? { price: 9.9, priceDisplay: '9.90' }
        )} — for documentation confirming your commercial creator status.`}
        action={
          <Btn onClick={onGetLicense}>
            <BadgeCheck size={13} />
            Get certification
          </Btn>
        }
      />
    </div>
  );
}
